import { Card, Group, Title, Grid, Text, Divider, Center, Loader, ScrollArea, Stack, Badge, Space, Container, Menu, ActionIcon } from "@mantine/core"
import { IconAdjustmentsHorizontal, IconArrowUp, IconDots, IconPencil, IconPhone, IconPin, IconTrash } from "@tabler/icons-react"
import { formatAddress, useParentGuardianEditor } from "../../functions/programregistration.functions";
import { AdultParticipant, ChildParticipant, ParentGuardian } from "../../models/programregistration.models";
import { useProgramRegistrationState } from "../../state/programregistration.state";
import ParentGuardianListEditor from "./ParentGuardianListEditor";
import { useProgramGroupsQuery } from "../../api/program.api";
import { SessionSelectionType } from "../../models/programs.models";
import { DataTableColumn } from "mantine-datatable";
import CustomDatatable from "../Shared/CustomDatatable";
import classes from "./ParentGuardiansView.module.css";

const ParentGuardiansView = () => {
	const { programRegistration, isLoading } = useProgramRegistrationState();
	const { data: programGroups } = useProgramGroupsQuery();

	const programGroup = programGroups?.find(g => g.Id === (programRegistration?.Data.ProgramGroupId ?? 0));

	// if (!isLoading && (programRegistration?.Data?.ParentGuardians.length ?? 0) === 0)
	// {
	// 	if (programGroup === undefined || programGroup.ParticipantType === ProgramParticipantType.Adults || 
	// 		(programGroup.ParticipantType === ProgramParticipantType.AdultsAndChildren))
	// 	return <></>
	// }

	const isSetup = programRegistration != null && programRegistration.Data.ParentGuardians.length > 0;
	const useNewDesign = import.meta.env.VITE_NEW_DESIGN === "true";

	if (!isSetup && programGroup?.SessionSelectionType == SessionSelectionType.Fixed)
		return <></>;

	return <>
		{useNewDesign && <>
		<Space h={30} />
		<Group justify="space-between" wrap="nowrap">
			<Group gap="xs">
				<Title order={3}>Parents / Guardians</Title>
			</Group>
			{/* {!isLoading && */}
			{/* <Button variant="light" size="xs" sx={{ alignSelf: 'flex-start' }} ><IconPencil /> Edit</Button> */}
			{/* } */}
			{programRegistration && <ParentGuardianListEditor />}
			
		</Group>
		<Divider my="sm" />
		{(isLoading) && <Center h={150} mx="auto">
			<Loader />
		</Center>}
		{!isSetup && programRegistration && <>
			<Center h={100}>
				<Text c="dimmed">Optionally add one or more parents/guardians</Text>
			</Center>
		</>}
		<ParentGuardiansList data={programRegistration?.Data?.ParentGuardians ?? []} />
		<Group px="xs" pt={5} gap={0}>
			<IconArrowUp size={16} color="var(--mantine-color-gray-5)" />
			<Text fz="xs" c="dimmed" >Click on a row for more information</Text>
		</Group>
		<Space h="md" />
		</>}

		{!useNewDesign && <>
		{/* <Card shadow="lg" mb="sm" radius="lg" bd="1px solid var(--mantine-color-indigo-outline)"> */}
		<Card shadow="lg" withBorder mb="sm">
			<Group justify="space-between" mb="lg" wrap="nowrap">
				<Group gap="xs">
					<IconAdjustmentsHorizontal />
					<Title order={3}>Parents / Guardians</Title>
				</Group>
				{/* {!isLoading && */}
				{/* <Button variant="light" size="xs" sx={{ alignSelf: 'flex-start' }} ><IconPencil /> Edit</Button> */}
				{/* } */}
				{programRegistration && <ParentGuardianListEditor />}
				
			</Group>
			{(isLoading) && <Center h={150} mx="auto">
				<Loader />
			</Center>}
			{!isSetup && programRegistration && <>
				<Center h={100}>
					<Text c="dimmed">Optionally add one or more parents/guardians</Text>
				</Center>
			</>}

			<ScrollArea.Autosize type="hover" mah={350}>
				
			{programRegistration?.Data?.ParentGuardians.map((parentGuardian, index) => {
				let adultParticipant = parentGuardian.Type === "adult" ? parentGuardian as AdultParticipant : null;
				let childParticipant = parentGuardian.Type === "child" ? parentGuardian as ChildParticipant : null;
				return <div key={index} style={{ margin: "calc(1rem / 2)" }}>
					<Grid mb="xs">
						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Name:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text fw="bold">{parentGuardian.FirstName} {parentGuardian.LastName}</Text></Grid.Col>
						{/* <Grid.Col span={3} sm={3} py={0}><Text align="right" color="dimmed" size="sm">Gender:</Text></Grid.Col>
						<Grid.Col span={9} sm={3} py={0}><Text>{getGender(parentGuardian)}</Text></Grid.Col> */}
						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Email:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text>{parentGuardian.Email}</Text></Grid.Col>

						
					</Grid>
					<Divider mb="md" label="Emergency Contact" labelPosition="center" />
					<Grid mb="xs">
						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Location:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text>{parentGuardian.Location}</Text></Grid.Col>
						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Emergency Contact:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text>{parentGuardian.EmergencyContact}</Text></Grid.Col>
					</Grid>
					<Divider mb="md" label="Contact" labelPosition="center" />
					<Grid mb="xs">
						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Home Phone:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text>{parentGuardian.HomePhone}</Text></Grid.Col>

						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Cell Phone:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text>{parentGuardian.MobilePhone}</Text></Grid.Col>

						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Address:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text>{formatAddress(parentGuardian.Address)}</Text></Grid.Col>
					</Grid>
					
					{index < programRegistration.Data.ParentGuardians.length - 1 && <Divider mb="md" size={3} />}
				</div>
			})}
			
			</ScrollArea.Autosize>
		</Card>
		</>}
	</>
}

export default ParentGuardiansView

interface ParentGuardianCardProps {
	parentGuardian: ParentGuardian;
}

const ParentGuardianCard = ({ parentGuardian }: ParentGuardianCardProps) => {
	return <Card className={classes.parentGuardianCard} p="xs">
		<Group>
			<Stack gap={5}>
				<Stack gap={0}>
					<Text size="sm" fw="bold">{parentGuardian?.Salutation} {parentGuardian.FirstName} {parentGuardian.LastName}</Text>
					<Text size="xs" c="dimmed">{formatAddress(parentGuardian.Address, false)}</Text>
					<Text size="xs" c="dimmed">{parentGuardian.Email}</Text>
					{/* <Text size="xs" c="dimmed">{parentGuardian.HomePhone} {parentGuardian.MobilePhone}</Text> */}
				</Stack>
				<Group>
					<Badge bg="red.8" radius="sm" px={5}>
						<Group gap={5} wrap="initial">
						<IconPhone size={14}  /> 
						Grandfather Frank Crampton {parentGuardian.EmergencyContact}
						</Group>
					</Badge>
					<Badge bg="blue.8" radius="sm" px={5}>
						<Group gap={5}>
							<IconPin size={14}  /> 
							{parentGuardian.Location}
						</Group>
					</Badge>
				</Group>
			</Stack>
		</Group>
	</Card>
}

interface ParentGuardiansListProps {
	data: ParentGuardian[];
}

export const ParentGuardiansList = ({ data }: ParentGuardiansListProps) => {
	const { openEditor, renderEditor } = useParentGuardianEditor();

	const columns: DataTableColumn<ParentGuardian>[] = [
		{ 
			accessor: 'FirstName',
			title: 'Name',
			// width: 100,
			textAlign: 'left',
			render: (item) => {
				return <Text fw="bold" inherit>{item.FirstName} {item.LastName}</Text>
			}
		},
		{ 
			accessor: 'EmergencyContact',
			title: 'Emergency Contact',
			noWrap: true,
			// sortable: true,
			render: (item) => {
				return <>{item.EmergencyContact}</>
			},
		},
		{ 
			accessor: 'Location',
			title: 'Location',
			noWrap: true,
			// sortable: true,
			render: (item) => {
				return <>{item.Location}</>
			},
		},
		{
			accessor: 'actions',
			title: <></>,
			hidden: true,
			// textAlign: 'right',
			render: (item) => (
				<Group gap={0} justify="center" wrap="nowrap">
					<Menu position="bottom-end" shadow="md" offset={2}>
						<Menu.Target>
							<ActionIcon onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} variant="subtle" size={26}><IconDots size={16} /></ActionIcon>
							{/* <Button onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} size="compact-xs" h={25} variant="subtle">
								<IconDots size={16} />
							</Button> */}
						</Menu.Target>
						<Menu.Dropdown onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
							<Menu.Label>Actions</Menu.Label>
							<Menu.Item onClick={() => openEditor(item.Id)} leftSection={<IconPencil size={16} />}>Edit</Menu.Item>
							<Menu.Item leftSection={<IconTrash size={16} />}>Remove</Menu.Item>
							{/* <Menu.Item disabled leftSection={<IconCopy size={16} />}>Duplicate</Menu.Item>
							{invoice.Status == InvoiceStatus.Draft &&
							<Menu.Item onClick={() => openDeleteModal(invoice)} color="red" leftSection={<IconX size={16} />}>Delete draft</Menu.Item>
							}
							<Menu.Divider />
							<Menu.Label>Connections</Menu.Label>
							<Menu.Item component={Link} to={`/customers/${invoice.CustomerId}`} leftSection={<IconUser size={16} />}>View customer</Menu.Item> */}
						</Menu.Dropdown>
					</Menu>
				</Group>
			),
		}
	];

	return <>
		{/* {renderEditor} */}
		<CustomDatatable
			idAccessor="Id"
			columns={columns}
			rows={data}
			rowExpansion={{
				content: ({ record }) => {
					return <>
						<Container bg="var(--mantine-color-gray-light)" p="xs" style={{ borderRadius: 5 }}>
							<Grid>
								<Grid.Col span={{ sm: 6 }}>
									<Text size="xs" fw="bold">Email</Text>
									<Text size="xs">{record.Email}</Text>
									<Space h={10} />
									<Text size="xs" fw="bold">Address</Text>
									<Text size="xs">{formatAddress(record.Address)}</Text>
								</Grid.Col>
								<Grid.Col span={{ sm: 6 }}>
									<Text size="xs" fw="bold">Home Phone</Text>
									<Text size="xs">{record.HomePhone}</Text>
									<Space h={10} />
									<Text size="xs" fw="bold">Mobile Phone</Text>
									<Text size="xs">{record.MobilePhone}</Text>
								</Grid.Col>
							</Grid>

						</Container>
					</>
				}
			}}
			isLoading={false}
			enablePagination={false}
			pinLastColumn={false}
			noRecordsText="No parents/guardians"
			// defaultRowsPerPage={10}
			// enableSorting={false}
			// defaultSortColumn="Created"
			// defaultSortDirection="desc"

			minHeight={100}
			// onRowClick={() => {
				// navigate({ pathname: `/invoices/${invoice.InvoiceId}`});
			// }}
		/>
	</>
}